export const transformVariantsPayloadToEventProperties = (featureFlagVariants: Record<string, unknown>, stringifyValues = false) =>
  Object.keys(featureFlagVariants).reduce(
    (acc, key) => {
      // For multiple-variant feature flags, we will have variant or `false` in case of disabled feature flag.
      // For single-variant feature flags, we will have the a boolean variant denoting if it is enabled or not.
      if (featureFlagVariants[key]) {
        acc[`$feature/${key}`] = stringifyValues ? String(featureFlagVariants[key]) : featureFlagVariants[key];
        // $active_feature_flags is an array of all the enabled feature flags
        acc['$active_feature_flags'] = ((acc['$active_feature_flags'] as string[]) ?? []).concat(key);
      }
      return acc;
    },
    {} as Record<string, unknown>,
  );
